import React, { useState, useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { CircularProgress } from "@material-ui/core";
import { importFlow } from "../services/flowBuilder";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { i18n } from "../translate/i18n";

const FlowImportModal = ({ open, onClose }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  
  const inputFileRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleImport = async () => {
    if (!file) {
      toast.error(i18n.t("flowbuilderModal.import.selectZip"));
      return;
    }
    try {
      setLoading(true);
      const { flowId } = await importFlow(file);
      toast.success(i18n.t("flowbuilderModal.import.success"));
      onClose();
      history.push(`/flowbuilder/${flowId}`);
    } catch (err) {
      console.error(err);
      toast.error(i18n.t("flowbuilderModal.import.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{i18n.t("flowbuilderModal.import.title")}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography>{i18n.t("flowbuilderModal.import.description")}</Typography>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Button
              variant="contained"
              onClick={() => inputFileRef.current.click()}
              sx={{
                backgroundColor: "var(--primaryColor)",
                "&:hover": {
                  backgroundColor: "var(--primaryColor)",
                  filter: "brightness(0.9)",
                },
              }}
            >
              {i18n.t("flowbuilderModal.buttons.chooseFile")}
            </Button>
            <Typography variant="body2" color="textSecondary">
              {file ? file.name : i18n.t("flowbuilderModal.import.noFile")}
            </Typography>
            <input
              ref={inputFileRef}
              type="file"
              accept=".zip"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="secondary">
          {i18n.t("flowbuilderModal.buttons.cancel")}
        </Button>
        <Button
          onClick={handleImport}
          variant="contained"
          disabled={loading || !file}
          sx={{
            backgroundColor: "var(--primaryColor)",
            "&:hover": {
              backgroundColor: "var(--primaryColor)",
              filter: "brightness(0.9)",
            },
            "&.Mui-disabled": {
              backgroundColor: 'rgba(0, 0, 0, 0.12)'
            }
          }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            i18n.t("flowbuilderModal.buttons.import")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowImportModal;
